export const styles = {
	buttonsContainer: {
		gap: '2rem',
	},
	directionText: {
		fontSize: '1.8rem',
		marginY: '0',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #388A12 0%, #A8E063 100%)',
	},
	header: {
		opacity: '87%',
		fontSize: '15px',
		marginY: '2rem',
	},
}
